import OrdersView from './OrdersView';
import { withI18n } from 'react-i18next';

export default withI18n()(OrdersView);
